var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "serviceDetailsModal",
        size: "lg",
        "hide-header-close": "",
        "no-stacking": "",
        title: _vm.$t("message.service_details"),
      },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function ({ cancel }) {
            return [
              _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "permission",
                      rawName: "v-permission",
                      value: _vm.PERMISSIONS.PORTFOLIO_MANAGEMENT,
                      expression: "PERMISSIONS.PORTFOLIO_MANAGEMENT",
                    },
                  ],
                  attrs: { size: "md", variant: "outline-danger" },
                  on: {
                    click: function ($event) {
                      return _vm.deleteService()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("message.delete")))]
              ),
              _c(
                "b-button",
                {
                  attrs: { size: "md", variant: "secondary" },
                  on: {
                    click: function ($event) {
                      return cancel()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("message.close")))]
              ),
              _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "permission",
                      rawName: "v-permission",
                      value: _vm.PERMISSIONS.PORTFOLIO_MANAGEMENT,
                      expression: "PERMISSIONS.PORTFOLIO_MANAGEMENT",
                    },
                  ],
                  attrs: { size: "md", variant: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.updateService()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("message.update")))]
              ),
            ]
          },
        },
      ]),
    },
    [
      _c(
        "b-tabs",
        {
          staticClass: "body-bg-color",
          staticStyle: { border: "0", padding: "0" },
        },
        [
          _c(
            "b-tab",
            {
              staticClass: "body-bg-color",
              staticStyle: { border: "0", padding: "0" },
              attrs: { active: "" },
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function () {
                    return [
                      _c("i", { staticClass: "fa fa-cube" }),
                      _vm._v(" " + _vm._s(_vm.$t("message.identity"))),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _c(
                "b-card",
                [
                  _c("b-input-group-form-input", {
                    attrs: {
                      id: "service-name-input",
                      "input-group-size": "mb-3",
                      type: "text",
                      lazy: "true",
                      required: "true",
                      feedback: "true",
                      autofocus: "false",
                      label: _vm.$t("message.service_name"),
                      tooltip: this.$t("message.service_name_desc"),
                      "feedback-text": _vm.$t("message.required_service_name"),
                      readonly: this.isNotPermitted(
                        _vm.PERMISSIONS.PORTFOLIO_MANAGEMENT
                      ),
                    },
                    model: {
                      value: _vm.service.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.service, "name", $$v)
                      },
                      expression: "service.name",
                    },
                  }),
                  _c("b-input-group-form-input", {
                    attrs: {
                      id: "service-version-input",
                      "input-group-size": "mb-3",
                      type: "text",
                      required: "false",
                      label: _vm.$t("message.version"),
                      tooltip: this.$t("message.service_version_desc"),
                      readonly: this.isNotPermitted(
                        _vm.PERMISSIONS.PORTFOLIO_MANAGEMENT
                      ),
                    },
                    model: {
                      value: _vm.service.version,
                      callback: function ($$v) {
                        _vm.$set(_vm.service, "version", $$v)
                      },
                      expression: "service.version",
                    },
                  }),
                  _c("b-input-group-form-input", {
                    attrs: {
                      id: "service-group-input",
                      "input-group-size": "mb-3",
                      type: "text",
                      required: "false",
                      label: _vm.$t("message.component_namespace_group_vendor"),
                      tooltip: this.$t("message.component_group_desc"),
                      readonly: this.isNotPermitted(
                        _vm.PERMISSIONS.PORTFOLIO_MANAGEMENT
                      ),
                    },
                    model: {
                      value: _vm.service.group,
                      callback: function ($$v) {
                        _vm.$set(_vm.service, "group", $$v)
                      },
                      expression: "service.group",
                    },
                  }),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "service-notes-form-group",
                        label: this.$t("message.description"),
                        "label-for": "service-notes-input",
                      },
                    },
                    [
                      _c("b-form-textarea", {
                        attrs: {
                          id: "service-notes-description",
                          rows: "3",
                          readonly: this.isNotPermitted(
                            _vm.PERMISSIONS.PORTFOLIO_MANAGEMENT
                          ),
                        },
                        model: {
                          value: _vm.service.description,
                          callback: function ($$v) {
                            _vm.$set(_vm.service, "description", $$v)
                          },
                          expression: "service.description",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("b-input-group-form-input", {
                    attrs: {
                      id: "service-uuid",
                      "input-group-size": "mb-3",
                      type: "text",
                      lazy: "false",
                      required: "false",
                      feedback: "false",
                      autofocus: "false",
                      disabled: "true",
                      label: _vm.$t("message.object_identifier"),
                      tooltip: this.$t("message.object_identifier_desc"),
                      readonly: true,
                    },
                    model: {
                      value: _vm.service.uuid,
                      callback: function ($$v) {
                        _vm.$set(_vm.service, "uuid", $$v)
                      },
                      expression: "service.uuid",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-tab",
            {
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function () {
                    return [
                      _c("i", { staticClass: "fa fa-building-o" }),
                      _vm._v("\n        " + _vm._s(_vm.$t("message.provider"))),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _c(
                "b-card",
                [
                  _c("b-input-group-form-input", {
                    attrs: {
                      id: "service-provider-name-input",
                      "input-group-size": "mb-3",
                      type: "text",
                      required: "false",
                      label: _vm.$t("message.provider_name"),
                      tooltip: this.$t("message.service_provider_name_desc"),
                    },
                    model: {
                      value: _vm.service.provider.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.service.provider, "name", $$v)
                      },
                      expression: "service.provider.name",
                    },
                  }),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "providerUrlsTable-Fieldset",
                        label: this.$t("message.urls"),
                        "label-for": "providerUrlsTable",
                      },
                    },
                    [
                      _c("bootstrap-table", {
                        ref: "providerUrlsTable",
                        attrs: {
                          id: "providerUrlsTable",
                          columns: _vm.providerUrlsTableColumns,
                          data: _vm.service.provider.urls,
                          options: _vm.providerUrlsTableOptions,
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "contactsTable-Fieldset",
                        label: this.$t("message.contacts"),
                        "label-for": "contactsTable",
                      },
                    },
                    [
                      _c("bootstrap-table", {
                        ref: "contactsTable",
                        attrs: {
                          id: "contactsTable",
                          columns: _vm.contactsTableColumns,
                          data: _vm.service.provider.contacts,
                          options: _vm.contactsTableOptions,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-tab",
            {
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function () {
                    return [
                      _c("i", { staticClass: "fa fa-globe" }),
                      _vm._v(" " + _vm._s(_vm.$t("message.endpoints"))),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _c(
                "b-card",
                [
                  _c("bootstrap-table", {
                    ref: "endpointTable",
                    attrs: {
                      columns: _vm.endpointTableColumns,
                      data: _vm.service.endpoints,
                      options: _vm.endpointTableOptions,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-tab",
            {
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function () {
                    return [
                      _c("i", { staticClass: "fa fa-server" }),
                      _vm._v(" " + _vm._s(_vm.$t("message.data"))),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _c(
                "b-card",
                [
                  _c("bootstrap-table", {
                    ref: "dataTable",
                    attrs: {
                      columns: _vm.dataTableColumns,
                      data: _vm.service.data,
                      options: _vm.dataTableOptions,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-tab",
            {
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function () {
                    return [
                      _c("i", { staticClass: "fa fa-external-link" }),
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("message.external_references"))
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _c(
                "b-card",
                [
                  _c("bootstrap-table", {
                    ref: "referencesTable",
                    attrs: {
                      columns: _vm.referencesTableColumns,
                      data: _vm.service.externalReferences,
                      options: _vm.referencesTableOptions,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }